import * as React from 'react';

interface Props {
    className: string;
    number: number;
    size?: 'large';
    isDarkMode?: boolean;
}

export default class WeightNumber extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    render() {
        const { number, size, className, isDarkMode } = this.props;

        let classNames: Array<string> = ['ddbc-weight-number', className];
        if (size) {
            classNames.push(`ddbc-weight-number--${size}`);
        }

        return (
            <span className={classNames.join(' ')}>
                <span
                    className={`ddbc-weight-number__number ${
                        isDarkMode ? 'ddbc-weight-number__number--dark-mode' : ''
                    }`}
                >
                    {number.toLocaleString()}
                </span>
                <span
                    className={`ddbc-weight-number__label ${isDarkMode ? 'ddbc-weight-number__label--dark-mode' : ''}`}
                >
                    lb.
                </span>
            </span>
        );
    }
}
